import type {User} from "../../mixins/UserMixin";
import {useStorage} from "./useStorage";

export const useLocalStorage = (user?: User) => useStorage(localStorage, user);